<template>
  <div class="reviewContainer"> 
    <div v-if="!editable">
      <div>
        <div>
          <RatingStars :rating="rating" />
        </div>
        <div class="contentContainer">
          <p name="review-content" class="is-5 subtitle">{{content}}</p>
        </div>
        <div class="nameContainer">
          <p class="name bold"> {{name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RatingStars from "../atoms/RatingStars";
export default {
  components: {
    RatingStars,
  },
  props: {
    rating: {
      default: 0,
      type: Number,
    },
    editable: {
      default: false,
      type: Boolean,
    },
    name: {
      default: "Anonymous",
      type: String,
    },
    content: String,
  },
};
</script>

<style lang="scss" scoped>

.contentContainer {
  margin-top: 0.7rem;
}

.name{
  color: black;
}

.nameContainer {
  width: 100%; 
  text-align: right;
}

.reviewContainer{
  width: 90%; 
  margin: 1rem auto; 
  box-shadow: 0 2px 3px #ababab; 
  padding:.5rem;

}

.reviewName{
  position: relative;
  bottom: 0;
}

@media only screen and (max-width: 768px){
  .subtitle {
    font-size: 1rem;
    margin-left: .5rem;
  }
}

</style>